import Konva from "konva";

export default () => ({
    config: null,
    scaleX: 1,
    scaleY: 1,
    stage: null,

    init () {
        this.config = JSON.parse(this.$root.dataset.config.replaceAll("'", ""))

        this.initStage(this.$root.dataset.canvaId)
        this.initLayers()
    },

    initStage(containerId) {
        if (this.stage === null) {
            this.stage = new Konva.Stage({
                container: containerId,
                width: window.innerWidth,
                height: window.innerWidth / 1.8
            })
        }
    },

    initLayers() {
        if (this.stage === null || this.config === null) {
            return
        }

        const layer = new Konva.Layer()
        this.stage.add(layer)

        Konva.Image.fromURL(this.config.template, async (img) => {

            this.scaleX = ((this.stage.width() / img.width()).toFixed(2) * 100 / 100) - 0.02
            this.scaleY = (this.stage.height() / img.height()).toFixed(2) * 100 / 100

            img.setAttrs({
                width: this.stage.width(),
                height: this.stage.height(),
                x: 0,
                y: 0,
                name: 'image'
            })

            layer.add(img)

            for (const layerId in this.config.layers) {
                const { fieldType, type, text, fontFamily, fontSize, fill, left, top } = this.config.layers[layerId]

                if (type === 'text' && fieldType !== 'verified-link') {
                    const textNode  = new Konva.Text({
                        x: Math.round(this.scaleX * left),
                        y: Math.round(this.scaleY * top),
                        text,
                        fontSize: Math.round(this.scaleX * fontSize),
                        fontFamily,
                        fill
                    });

                    layer.add(textNode)
                }
            }

            layer.draw()
        })
    },

    downloadURI(uri, name) {
        let link = document.createElement('a')
        link.download = name
        link.href = uri
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
    },

    saveImage() {
        if (this.stage === null || this.config === null) {
            return
        }

        const dataURL = this.stage.toDataURL({ pixelRatio: 3 });
        this.downloadURI(dataURL, `${this.config.key_cer}.png`);
    }
})